import { HttpMethod } from '@pool-league/shared-util-http';
import {
  EndpointPathParameters,
  GetOperation,
  PostOperation,
  PutOperation,
} from '../operation';

export const GET_PLAYERS: GetOperation<void> = {
  path: ['players'],
  method: HttpMethod.GET,
};

export const CREATE_PLAYER: PostOperation<void> = {
  path: ['players'],
  method: HttpMethod.POST,
};

export type PlayerByIdPathParameters = EndpointPathParameters<'playerId'>;

export const GET_PLAYER: GetOperation<keyof PlayerByIdPathParameters> = {
  path: ['players', { param: 'playerId' }],
  method: HttpMethod.GET,
};

export const UPDATE_PLAYER: PutOperation<keyof PlayerByIdPathParameters> = {
  path: ['players', { param: 'playerId' }],
  method: HttpMethod.PUT,
};

export const GET_PLAYER_FIXTURES: GetOperation<keyof PlayerByIdPathParameters> =
  {
    path: ['players', { param: 'playerId' }, 'fixtures'],
    method: HttpMethod.GET,
  };
